import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import App from './App';

import Auth0ProviderWithHistory from './components/Auth0Provider'; // Corrected path
import reportWebVitals from './reportWebVitals';

// CRITICAL: Capture Stripe payment parameters IMMEDIATELY before React renders
// This runs as soon as index.js loads, before React mounts
const currentUrl = new URL(window.location.href);
const paymentStatus = currentUrl.searchParams.get('payment');
const sessionId = currentUrl.searchParams.get('session_id');

if (paymentStatus === 'success' && sessionId) {
  console.log('💾 CRITICAL [index.js]: Capturing Stripe sessionId BEFORE React renders:', sessionId);
  
  // Store in sessionStorage to survive any redirects
  const existingPaymentInfo = sessionStorage.getItem('stripePaymentPending');
  let paymentData = existingPaymentInfo ? JSON.parse(existingPaymentInfo) : {};
  paymentData.sessionId = sessionId;
  paymentData.capturedAt = Date.now();
  paymentData.capturedBy = 'index.js (pre-render)';
  sessionStorage.setItem('stripePaymentPending', JSON.stringify(paymentData));
  
  console.log('✅ SessionId saved by index.js - available immediately to all components');
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Router>
      <Auth0ProviderWithHistory>
        <App />
      </Auth0ProviderWithHistory>
    </Router>
  </React.StrictMode>
);

reportWebVitals();
